import React from 'react';
import { motion } from 'framer-motion';
import { fadeUp, staggerContainer } from '../utils/constants';
export function PracticeAreas() {
  const areas = [{
    image: 'https://images.unsplash.com/photo-1450101499163-c8848c66ca85?w=600&q=80',
    title: 'Derecho Civil',
    desc: 'Contratos, responsabilidad civil, sucesiones y propiedad'
  }, {
    image: 'https://images.unsplash.com/photo-1589829545856-d10d557cf95f?w=600&q=80',
    title: 'Derecho Penal',
    desc: 'Defensa penal, delitos económicos, garantías constitucionales'
  }, {
    image: 'https://images.unsplash.com/photo-1521791136064-7986c2920216?w=600&q=80',
    title: 'Derecho Laboral',
    desc: 'Despidos, accidentes laborales, negociación colectiva'
  }, {
    image: 'https://images.unsplash.com/photo-1486406146926-c627a92ad1ab?w=600&q=80',
    title: 'Derecho Comercial',
    desc: 'Sociedades, fusiones, compliance corporativo'
  }, {
    image: 'https://images.unsplash.com/photo-1511895426328-dc8714191300?w=600&q=80',
    title: 'Derecho de Familia',
    desc: 'Divorcios, custodia, alimentos, adopción'
  }, {
    image: 'https://images.unsplash.com/photo-1524578271613-d550eacf6090?w=600&q=80',
    title: 'Derecho Administrativo',
    desc: 'Licitaciones, regulaciones, recursos administrativos'
  }];
  return <section id="areas" className="py-32 bg-grayLightest relative" data-id="element-165">
      <div className="max-w-7xl mx-auto px-6 relative z-10" data-id="element-166">
        <motion.div initial="hidden" whileInView="visible" viewport={{
        once: true,
        margin: '-100px'
      }} variants={staggerContainer} data-id="element-167">
          <motion.div variants={fadeUp} className="mb-20" data-id="element-168">
            <div className="flex items-center gap-4 mb-4" data-id="element-169">
              <div className="h-px w-12 bg-grayDarkest" data-id="element-170"></div>
              <span className="font-montserrat text-grayDarkest tracking-[0.2em] text-sm uppercase font-semibold" data-id="element-171">
                Especialidades
              </span>
            </div>
            <h2 className="heading-brutalist text-4xl md:text-5xl mb-6 text-grayDarkest" data-id="element-172">
              ÁREAS DE PRÁCTICA
            </h2>
            <p className="text-xl text-grayDarkest font-light max-w-2xl" data-id="element-173">
              Cobertura legal integral para cada aspecto de su vida y negocio.
            </p>
          </motion.div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-174">
            {areas.map((area, index) => <motion.div key={index} variants={fadeUp} className="group bg-white border border-grayMid shadow-sm hover:shadow-lg transition-all duration-500 cursor-pointer overflow-hidden flex flex-col" data-id="element-175">
                <div className="h-48 w-full overflow-hidden relative" data-id="element-176">
                  <div className="absolute inset-0 bg-grayDarkest/20 group-hover:bg-transparent transition-colors duration-500 z-10" data-id="element-177"></div>
                  <img src={area.image} alt={area.title} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700" data-id="element-178" />
                </div>
                <div className="p-8 flex-1 flex flex-col" data-id="element-179">
                  <h3 className="font-montserrat text-xl font-bold mb-4 uppercase tracking-wide text-grayDarkest" data-id="element-180">
                    {area.title}
                  </h3>
                  <p className="text-grayDarkest font-light transition-colors duration-300 flex-1" data-id="element-181">
                    {area.desc}
                  </p>

                  <div className="mt-8 flex items-center text-sm font-montserrat text-grayDarkest font-semibold uppercase tracking-wider opacity-0 group-hover:opacity-100 transform translate-y-2 group-hover:translate-y-0 transition-all duration-300" data-id="element-182">
                    Saber más <span className="ml-2" data-id="element-183">→</span>
                  </div>
                </div>
              </motion.div>)}
          </div>
        </motion.div>
      </div>
    </section>;
}